import { connect } from "react-redux";

// Component
import SurveyDetail from "components/SurveyDetail";
// Utils
import history from "utils/history";
import api from "api";
// Actions
import {
  setSurveyDetail,
  setLocale,
  init,
  setErrors,
  setLoading, setAttributeLoading
} from "redux/modules/surveyDetail";
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { showSnackbar } from "redux/modules/snackbar";
import {isAdmin, isPlatform} from "utils/formatter";
import { STATUS as SURVEY_STATUS } from "models/Survey";
import { setSurveyDetail as setCreateSurveyDetail } from "redux/modules/createSurvey";
import { validate as baseInfoValidate } from "../CreateSurvey/BaseInfo";
import { validate as selectAttrValidate } from "../CreateSurvey/SelectAttr";
import { validate as baseWordValidate } from "../CreateSurvey/BaseWord";
import { validate as additionsValidate } from "../CreateSurvey/Additions";
import {exportEmployees, importEmployees, setEmployeeMaster} from "../../redux/modules/empolyeeMaster";

const messageFmt = (beforeStatus, afterStatus) => {
  switch (afterStatus) {
    case SURVEY_STATUS.READY:
      return "アンケートの確定を解除します。よろしいですか？";
    case SURVEY_STATUS.CONFIRM:
      return "アンケートを確定します。よろしいですか？";
    case SURVEY_STATUS.OPEN:
      return beforeStatus === SURVEY_STATUS.STOP
        ? "アンケートの公開を再開します。よろしいですか？"
        : "アンケートを公開します。よろしいですか？";
    case SURVEY_STATUS.STOP:
      return "アンケートの公開を中断します。よろしいですか？";
    case SURVEY_STATUS.FINISH:
      return "アンケートの公開を終了します。この操作は元に戻せません。 よろしいですか？";
    default:
      console.error(`未対応の値: ${{ beforeStatus, afterStatus }}`);
      return null;
  }
};

const createCSVContent = (data, fileName) => {
  // BOM の用意(文字化け対策)
  const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  // BOM 付き CSV ファイルの元となる Blob を作成
  const blob = new Blob([bom, data], { type: "text/csv" });

  if (isPlatform("IE")) {
    // IE
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    // createObjectURL を使って Blob URL を構築
    const link = document.createElement("a");
    link.style = "visibility:hidden";
    link.href = (window.URL || window.webkitURL).createObjectURL(blob);
    // ファイル名はサーバから取得
    link.download = fileName;
    // ダウンロード後、リンクは削除
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

const mapStateToProps = state => {
  return {
    surveyDetail: state.surveyDetail,
    createSurvey: state.createSurvey,
    employeeCount: state.employeeMaster.employeeCount
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => dispatch(init()),
  historyPush: path => history.push(path, ownProps),
  fetchSurveyDetail: () => {
    const { id } = ownProps.match.params;
    api
      .get(`survey_detail/${id}`)
      .then(res => {
        dispatch(setSurveyDetail(res));
        dispatch(setCreateSurveyDetail(res));
      })
      .catch(error => dispatch(openErrorDialog(error)));

      api
        .get(`employee_count/${id}`)
        .then(res => {
          dispatch(setEmployeeMaster(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
  },
  changeLocale: (event, localeId) => dispatch(setLocale(localeId)),
  // クリップボードへコピー
  copyToClipboard: text => {
    const input = document.createElement("input");
    input.setAttribute("id", "copyinput");
    document.body.appendChild(input);
    input.value = text;
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    dispatch(showSnackbar("クリップボードにコピーしました。"));
  },
  // 各種設定・管理の押下
  handleEdit: () => {
    const { id } = ownProps.match.params;
    history.push(`/edit_survey/${id}/base_info`, ownProps);
  },
  updateStatusTo: (status, survey, createSurvey) => () => {
    const errors = [];
    if (!survey.isOpened()) {
      if (
        baseInfoValidate({
          survey: createSurvey.survey,
          baseInfo: createSurvey.baseInfo
        }).length > 0
      ) {
        errors.push("基本情報の設定内容に不備があります。");
      }
      if (
        selectAttrValidate(createSurvey.baseInfo, createSurvey.selectAttr)
          .length > 0
      ) {
        errors.push("設問設定−属性設定の内容に不備があります。");
      }
      if (
        baseWordValidate(createSurvey.baseInfo, createSurvey.baseWord).length >
        0
      ) {
        errors.push("設問設定−基本設問文言設定の内容に不備があります。");
      }
      if (
        additionsValidate(createSurvey.baseInfo, createSurvey.additions)
          .length > 0
      ) {
        errors.push("設問設定−追加設問設定の内容に不備があります。");
      }
      dispatch(setErrors(errors));
      if (errors.length > 0) {
        window.scroll(0, 0);
        return;
      }
    }

    const params = {
      survey: {
        status,
        lockVersion: survey.lockVersion
      }
    };

    const dialogData = {
      title: "確認",
      contentText: messageFmt(survey.status, status),
      btnLabel: "更新",
      handleClick: () => {
        api
          .patch(`survey_detail/${survey.id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              window.scroll(0, 0);
              dispatch(setErrors(res.errors));
            } else {
              dispatch(setSurveyDetail(res));
              dispatch(showSnackbar("状態を更新しました。"));
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(setErrors({}));
    dispatch(openConfirmDialog(dialogData));
  },
  getCSV: surveyId => () => {
    dispatch(setLoading(true));
    api
      .get(`survey_detail/${surveyId}/export_csv`)
      .then(
        res => {
          createCSVContent(res.data, res.fileName);
          dispatch(setLoading(false));
        }
      )
      .catch(error => {
        dispatch(openErrorDialog(error));
        dispatch(setLoading(false));
      });
  },
  getSurveyAttributes: surveyId => () => {
    dispatch(setAttributeLoading(true));
    api
      .get(`survey_detail/${surveyId}/attribute_csv`)
      .then(res => {
        createCSVContent(res.data, res.fileName);
        dispatch(setAttributeLoading(false));
      })
      .catch(error => {
        dispatch(openErrorDialog(error));
        dispatch(setAttributeLoading(false));
      });
  },
  clickAttrSelectCard: () => {
    const { id } = ownProps.match.params;
    history.push(`/edit_survey/${id}/select_attr`, ownProps);
  },
  clickBasicSurveyCard: () => {
    const { id } = ownProps.match.params;
    history.push(`/edit_survey/${id}/base_word`, ownProps);
  },
  clickAdditionalSurveyCard: () => {
    const { id } = ownProps.match.params;
    history.push(`/edit_survey/${id}/additions`, ownProps);
  },
  clickCheckPreviewCard: surveyId => () => {
    history.push(`/survey_check_word/${surveyId}`, ownProps);
  },
  clickMonitoringCard: () => {
    const { id } = ownProps.match.params;
    history.push(`/survey_progress/${id}`, ownProps);
  },
  clickReportCard: () => {
    const { id } = ownProps.match.params;
    history.push(`/report/${id}`, ownProps);
  },
  onImportClick: () => {
    // Dispatch an action to handle the CSV import
    dispatch(importEmployees());
  },
  onExportClick: () => {
    // Dispatch an action to handle the CSV export
    dispatch(exportEmployees());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyDetail);



// WEBPACK FOOTER //
// ./src/containers/SurveyDetail/SurveyDetailContainer.js